import { SparkReward } from '../types'
import { getChainConfigEntry } from '@/config/chain'
import { ActionsViewState } from '@/features/actions/types'
import { ActionsView } from '@/features/actions/views/ActionsView'
import { MultiPanelDialog } from '@/features/dialogs/common/components/MultiPanelDialog'
import { DialogTitle } from '@/ui/atoms/dialog/Dialog'
import { TransactionOverview } from '@/ui/organisms/transaction-overview/TransactionOverview'

export interface ClaimSparkRewardsViewProps {
  actionsViewState: ActionsViewState
  claims: SparkReward[]
  chainId: number
}

export function ClaimSparkRewardsView({ claims, actionsViewState, chainId }: ClaimSparkRewardsViewProps) {
  return (
    <MultiPanelDialog>
      <DialogTitle>Claim rewards</DialogTitle>

      <TransactionOverview>
        {claims.map(({ token, amountToClaim }, index) => (
          <TransactionOverview.Row key={token.symbol}>
            <TransactionOverview.Label>Reward{claims.length > 1 ? ` ${index + 1}` : ''}</TransactionOverview.Label>
            <TransactionOverview.TokenAmount token={token} amount={amountToClaim} showUsdAmount="when-positive" />
          </TransactionOverview.Row>
        ))}
        <TransactionOverview.Row>
          <TransactionOverview.Label>Network</TransactionOverview.Label>
          <div className="typography-label-2 flex items-center gap-1.5 text-primary">
            <img src={getChainConfigEntry(chainId).meta.logo} alt="network logo" className="size-4" />
            {getChainConfigEntry(chainId).meta.name}
          </div>
        </TransactionOverview.Row>
      </TransactionOverview>

      <ActionsView state={actionsViewState} actionsGridLayout="compact" allowChangeWhenActionsInProgress={false} />
    </MultiPanelDialog>
  )
}
